import React, {
  forwardRef,
  useCallback,
  useEffect,
  useRef,
  useState,
  useImperativeHandle,
  CSSProperties,
} from "react";

import {
  Expression,
  GridData,
  GridDataOptions,
  GridProps,
  Pager,
  Sorter,
} from "../../Component/schema";
import {
  getDataSource,
  getDictionaryMapper,
  getGridData,
  getPagination,
} from "../../../../../component/DataList/util";
import {
  Button,
  Icon,
  List,
  Checkbox,
  Result,
  SearchBar,
  InputItem,
  Toast,
  DatePicker 
} from "antd-mobile";
import { Space ,Dialog} from "antd-mobile-v5";
import { DownOutline, UpOutline } from "antd-mobile-icons";
import instance from "../../../../../util/axios";
import DictionarySelect from "../../../../../component/CheckBoxItem";
import moment from "moment";

const { Item } = List;
const Brief = Item.Brief;
const CheckboxItem = Checkbox.CheckboxItem;
interface InputFields {
  uuid: string;
  quantity?: string;
  pieces?: string;
}
const AgainList = forwardRef(
  (
    {
      url,
      pagination,
      descriptions,
      isCutting,
      sorter,
      pageSize = 10,
      homeParams,
      getProId,
    }: GridProps,
    ref: any
  ) => {
    const searchFormRef = useRef<{ [key: string]: string }>({});
    const [pageIndex, setPageIndex] = useState<number>(1);
    const [keyword, setKeyword] = useState<string>();
    const [barWord, setBarWord] = useState<string>();
    const filledStyle: CSSProperties = {
      color: "#FD5A5F",
    };
    const notFilledStyle: CSSProperties = {
      color: "black",
    };
    //新增
    const [completionHome, setCompletionHome] = useState<any>({
      expand: false,
      isReturning: "",
      isOther: "", //车间帮工
      workshopId: "",
      procedureId: "",
      remarkId: "",
      staffId: "",
      orderCalType: "",
      useGroup: "",
      groupId: "",
      joinedStaffsId: "",
    });
    const [procedureFilter, setProcedureFilter] = useState<string>("");
    const [remarkFilter, setRemarkFilter] = useState<string>("");
    const [staffFilter, setStaffFilter] = useState<string>("");
    const [groupFilter, setGroupFilter] = useState<string>("");
    /**
     * 仅查询数据
     * @param pager
     * @param currentSorter
     */
    const getData = useCallback(
      async function getData(
        pager?: Pager,
        currentSorter?: Sorter
      ): Promise<GridData> {
        const options: GridDataOptions = {
          url,
          dictionaryMapper: getDictionaryMapper(descriptions),
          pagination: pagination !== false,
          pager: pager,
          sorter: currentSorter && currentSorter.order ? currentSorter : sorter,
          searchForm: searchFormRef.current,
          fuzzySearch: "",
          innerDescriptions: descriptions,
        };
        return await getGridData(options);
      },
      [descriptions, pagination, sorter, url]
    );

    /**
     * 加载数据
     * @param pager
     * @param currentSorter
     */
    const loadData = useCallback(
      async function loadData(pager?: Pager, currentSorter?: Sorter) {
        const gridData = await getData(pager, currentSorter);
        const gridDataCopy = {
          ...gridData,
          data: gridData?.data[0]?.completions,
        };
        gridDataCopy &&
          gridDataCopy.data &&
          gridDataCopy.data.length > 0 &&
          gridDataCopy.data.forEach((item: any, index: any) => {
            if (!item.uuid) item.uuid = (+new Date()).toString() + index;
          });
        if (gridDataCopy) {
          setSelectedRows((prevState) => {
            return getDataSource(gridDataCopy, descriptions);
          });
        }
      },
      [descriptions, getData]
    );

    useEffect(() => {
      loadData({ pageIndex, pageSize: pageSize }).then();
    }, [loadData, pageIndex, pageSize]);

    // 选中行数据
    const [selectedRows, setSelectedRows] = useState<any[]>([]);
    useImperativeHandle(ref, () => ({
      getCheckedItem() {
        return selectedRows?.filter((item) =>
          item.procedureIds?.includes(completionHome.procedureId)
        );
      },
      clearCheckedItem() {
        setSelectedRows([]);
      },
      getcompletionHome() {
        return completionHome;
      },
    }));
    useEffect(() => {
      instance.get(`/erp/workshop/getWorkshopDeptByUser`).then((resp) => {
        if (resp.data.Status === "1" && resp.data.Data) {
          if (resp.data.Data.workshopId) {
            setProcedureFilter(
              " workshopId like '" + resp.data.Data.workshopId + "'"
            );
            setGroupFilter(" workshopId='" + resp.data.Data.workshopId + "'");
          }
          if (resp.data.Data.departmentIds) {
            setStaffFilter(
              " find_in_set(departmentId,'" +
                resp.data.Data.departmentIds +
                "')>0"
            );
          }
        }
      });
    }, []);
    useEffect(() => {
      setCompletionHome({
        expand: false,
        isReturning: homeParams?.isReturning,
        isOther: homeParams?.isOther, //车间帮工
        workshopId: homeParams?.workshopId,
        procedureId: homeParams?.procedureId,
        remarkId: homeParams?.remarkId,
        staffId: homeParams?.staffId,
        orderCalType: homeParams?.orderCalType,
        useGroup: homeParams?.useGroup,
        groupId: homeParams?.groupId,
        joinedStaffsId: homeParams?.joinedStaffsId,
        submitId: homeParams?.submitId,
      });
    }, [homeParams]);

    return (
      <>
        <List>
          <div style={{ width: "100%", display: "inline-flex" }}>
            <SearchBar
              style={{ width: "85%", height: 50, fontSize: 16 }}
              value={barWord}
              placeholder="Search"
              maxLength={20}
              onChange={(value) => {
                setBarWord(value);
              }}
            />
            <Button
              style={{ width: "15%", height: 50, fontSize: 16 }}
              onClick={() => {
                setKeyword(barWord);
              }}
            >
              查询
            </Button>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              fontSize: 16,
              padding: "16px",
              paddingBottom: 0,
            }}
            onClick={() => {
              setCompletionHome((prevState: any) => ({
                ...prevState,
                expand: !completionHome?.expand,
              }));
            }}
          >
            <div style={{ marginBottom: 4 }}>填报主信息</div>
            {completionHome?.expand ? <UpOutline /> : <DownOutline />}
          </div>
          {completionHome?.expand && (
            <div>
              <List>
                <DictionarySelect
                  title={"返修填报"}
                  multiple={false}
                  dictionary={"dict_order_free_bool"}
                  value={completionHome.isReturning}
                  onChange={(value) => {
                    setCompletionHome((prevState: any) => ({
                      ...prevState,
                      isReturning: value,
                    }));
                  }}
                />
              </List>
              <List>
                <DictionarySelect
                  title={"车间帮工"}
                  multiple={false}
                  dictionary={"dict_order_free_bool"}
                  value={completionHome.isOther}
                  onChange={(value) => {
                    setCompletionHome((prevState: any) => ({
                      ...prevState,
                      isOther: value,
                    }));
                  }}
                />
              </List>
              {completionHome.isOther === "1" && (
                <List>
                  <DictionarySelect
                    title={"选择车间"}
                    multiple={false}
                    dictionary={"erp_workshop"}
                    value={completionHome.workshopId}
                    onChange={(value) => {
                      setCompletionHome((prevState: any) => ({
                        ...prevState,
                        workshopId: value,
                      }));
                      setProcedureFilter(" workshopId like '" + value + "'");
                    }}
                  />
                </List>
              )}
              <List>
                <DictionarySelect
                  title={"工序"}
                  multiple={false}
                  dictionary={"erp_procedure"}
                  originFilter={procedureFilter}
                  value={completionHome.procedureId}
                  onChange={(value) => {
                    setCompletionHome((prevState: any) => ({
                      ...prevState,
                      procedureId: value,
                      remarkId: "",
                    }));
                    getProId?.(value);
                    instance
                      .post(`/erp/procedure/getRemarkIdsByProcedureId`, {
                        procedureId: value,
                      })
                      .then((resp) => {
                        if (resp.data.Status === "1" && resp.data.Data) {
                          setRemarkFilter(
                            " find_in_set(uuid,'" + resp.data.Data + "')>0"
                          );
                        }
                      });
                  }}
                />
              </List>
              <List>
                <DictionarySelect
                  title={"生产产品"}
                  multiple={false}
                  dictionary={"erp_remark_product"}
                  originFilter={remarkFilter}
                  value={completionHome.remarkId}
                  onChange={(value) => {
                    setCompletionHome((prevState: any) => ({
                      ...prevState,
                      remarkId: value,
                    }));
                  }}
                />
              </List>
              <List>
                <DictionarySelect
                  title={"填报人"}
                  multiple={false}
                  dictionary={"base_staff"}
                  originFilter={staffFilter}
                  value={completionHome.staffId}
                  onChange={(value) => {
                    setCompletionHome((prevState: any) => ({
                      ...prevState,
                      staffId: value,
                    }));
                  }}
                />
              </List>
              <List>
                <DictionarySelect
                  title={"类型"}
                  multiple={false}
                  dictionary={"dict_order_production_cal_type"}
                  value={completionHome.orderCalType}
                  onChange={(value) => {
                    if (value !== "2") {
                      setCompletionHome((prevState: any) => ({
                        ...prevState,
                        orderCalType: value,
                        useGroup: "",
                        groupId: "",
                        joinedStaffsId: "",
                      }));
                    } else {
                      setCompletionHome((prevState: any) => ({
                        ...prevState,
                        orderCalType: value,
                      }));
                    }
                  }}
                />
              </List>

              <List>
              <DatePicker
                mode="date"
                title="选择日期"
                value={completionHome.workDate ? new Date(completionHome.workDate) : undefined}
                onChange={(value) => {
                    setCompletionHome((prevState: any) => ({
                      ...prevState,
                      workDate: moment(value).format("YYYY-MM-DD"),
                    }));
                  }}>

                <List.Item arrow="horizontal">
                工作日期
                </List.Item>
              </DatePicker>
              </List>

              <List>
                <DictionarySelect
                  title={"使用已有组别"}
                  multiple={false}
                  disabled={completionHome.orderCalType !== "2"}
                  dictionary={"dict_order_free_bool"}
                  value={completionHome.useGroup}
                  onChange={(value) => {
                    setCompletionHome((prevState: any) => ({
                      ...prevState,
                      useGroup: value,
                    }));

                    if (value !== "2") {
                      setCompletionHome((prevState: any) => ({
                        ...prevState,
                        useGroup: value,
                        groupId: "",
                      }));
                    } else {
                      setCompletionHome((prevState: any) => ({
                        ...prevState,
                        useGroup: value,
                      }));
                    }
                  }}
                />
              </List>
              <List>
                <DictionarySelect
                  title={"选择组名称"}
                  multiple={false}
                  dictionary={"erp_work_group"}
                  originFilter={groupFilter}
                  disabled={
                    completionHome.orderCalType !== "2" ||
                    completionHome.useGroup !== "1"
                  }
                  value={completionHome.groupId}
                  onChange={async (value) => {
                    setCompletionHome((prevState: any) => ({
                      ...prevState,
                      groupId: value,
                    }));
                    if (value) {
                      const resp = await instance.post(
                        `/erp/sku/workshop/getWorkGroupById`,
                        { uuid: value }
                      );
                      if (resp.data.Status === "1" && resp.data.Data) {
                        setCompletionHome((prevState: any) => ({
                          ...prevState,
                          joinedStaffsId: resp.data.Data.staffIds || "",
                        }));
                      }
                    }
                  }}
                />
              </List>
              <List>
                <DictionarySelect
                  title={"参与员工"}
                  multiple={true}
                  disabled={completionHome.orderCalType !== "2"}
                  dictionary={"base_staff"}
                  originFilter={staffFilter}
                  value={completionHome.joinedStaffsId}
                  onChange={(value) => {
                    setCompletionHome((prevState: any) => ({
                      ...prevState,
                      joinedStaffsId: value,
                    }));
                  }}
                />
              </List>
            </div>
          )}
          {selectedRows
            ?.filter((items) => {
              let flag = false;
              if (keyword) {
                if (items?.orderNo?.includes(keyword)) {
                  flag = true;
                }
                if (items?.dealerName?.includes(keyword)) {
                  flag = true;
                }
                if (items?.skuName?.includes(keyword)) {
                  flag = true;
                }
                if (items?.gear?.includes(keyword)) {
                  flag = true;
                }
                if (items?.gearModel?.includes(keyword)) {
                  flag = true;
                }
                if (items?.color?.includes(keyword)) {
                  flag = true;
                }
                if (items?.formulaName?.includes(keyword)) {
                  flag = true;
                }
              } else {
                flag = true;
              }
              return flag;
            })
            .filter((item) =>
              item.procedureIds?.includes(completionHome.procedureId)
            )
            .map((item, i) => (
              <CheckboxItem
              style={{ marginLeft: 12 }}
              key={item.uuid}
              checked={selectedRows.some(
                (selectedItem) => selectedItem.uuid === item.uuid
              )}
              onChange={(e: { target: { checked: any } }) => {
                Dialog.confirm({
                  content: "确定要删除该条数据吗？",
                  onConfirm: () => {
                    const copy = JSON.parse(JSON.stringify(selectedRows));
                    const index = copy.findIndex(
                      (a: any) => a.uuid === item.uuid
                    );
                    copy.splice(index, 1); // 删除取消的选项
                    // item.quantity = "";
                    // item.pieces = "";
                    setSelectedRows(copy);
                  },
                });
                //const copy = JSON.parse(JSON.stringify(selectedRows));
                //const index = copy.findIndex(
               //   (a: any) => a.uuid === item.uuid
                //);
               // copy.splice(index, 1); // 删除取消的选项
                //setSelectedRows(copy);
              }}
            >
              <Item wrap align="top" multipleLine key={item?.uuid}>
                <Brief
                  style={item["isFilled"] == "1" ? filledStyle : notFilledStyle}
                >
                  {descriptions[0].fieldShowName!}：
                  {item[descriptions[0].fieldName!]}
                  {descriptions.slice(1, descriptions.length).map((desc) => (
                    <div
                      style={{
                        whiteSpace: "normal",
                        wordBreak: "break-all",
                        overflow: "hidden",
                      }}
                    >
                      {`${desc.fieldShowName}: ${item[desc.fieldName!]}`}
                    </div>
                  ))}
                </Brief>
                {completionHome.isReturning !== "1" && isCutting && (
                  <>
                    <div style={{ marginLeft: -16 }}>
                      <InputItem
                        style={{ marginLeft: -6, textAlign: "left" }}
                        id={item.uuid}
                        min={0}
                        type={"digit"}
                        placeholder={"请填写"}
                        disabled={item?.isFilled == "1"}
                        value={item?.quantity}
                        onChange={(value) => {
                          const copySelectedRows = JSON.parse(
                            JSON.stringify(selectedRows)
                          );
                          copySelectedRows[i].quantity = value;
                          setSelectedRows(copySelectedRows);
                        }}
                      >
                        本次下料数量:
                      </InputItem>
                    </div>
                  </>
                )}
                {completionHome.isReturning !== "1" && !isCutting && (
                  <>
                    <div style={{ marginLeft: -16 }}>
                      <InputItem
                        style={{ marginLeft: -6, textAlign: "left" }}
                        id={item.uuid}
                        min={0}
                        type={"digit"}
                        placeholder={"请填写"}
                        disabled={item?.isFilled == "1"}
                        value={item?.quantity}
                        onFocus={(e) => {
                          //@ts-ignore
                          e.target?.scrollIntoView({behavior: "smooth",block: "nearest"});
                        }}
                        onChange={(value) => {
                          // 输入框填写工作量时 要同步到已选项
                          const copySelectedRows = JSON.parse(
                            JSON.stringify(selectedRows)
                          );
                          copySelectedRows[i].quantity = value;
                          setSelectedRows(copySelectedRows);
                        }}
                      >
                        本次组数:
                      </InputItem>
                      <InputItem
                        style={{ marginLeft: -6, textAlign: "left" }}
                        id={item.uuid + "pieces"}
                        min={0}
                        type={"digit"}
                        disabled={!item.totalPieces || item?.isFilled == "1"}
                        placeholder={"请填写"}
                        value={item?.pieces}
                        onChange={(value) => {
                          const copySelectedRows = JSON.parse(
                            JSON.stringify(selectedRows)
                          );
                          copySelectedRows[i].pieces = value;
                          setSelectedRows(copySelectedRows);
                        }}
                      >
                        本次柱/档数:
                      </InputItem>
                    </div>
                  </>
                )}
                {completionHome.isReturning === "1" && (
                  <>
                    <div style={{ marginLeft: -16 }}>
                      <InputItem
                        style={{ marginLeft: -6, textAlign: "left" }}
                        id={item.uuid}
                        min={0}
                        type={"digit"}
                        placeholder={"请填写"}
                        disabled={item?.isFilled == "1"}
                        value={item?.quantity}
                        onChange={(value) => {
                          const copySelectedRows = JSON.parse(
                            JSON.stringify(selectedRows)
                          );
                          copySelectedRows[i].quantity = value;
                          setSelectedRows(copySelectedRows);
                        }}
                      >
                        (返修)本次组数:
                      </InputItem>
                      <InputItem
                        style={{ marginLeft: -6, textAlign: "left" }}
                        id={item.uuid + "pieces"}
                        min={0}
                        type={"digit"}
                        placeholder={"请填写"}
                        disabled={item?.isFilled == "1"}
                        value={item?.pieces}
                        onChange={(value) => {
                          const copySelectedRows = JSON.parse(
                            JSON.stringify(selectedRows)
                          );
                          copySelectedRows[i].pieces = value;
                          setSelectedRows(copySelectedRows);
                        }}
                      >
                        (返修)本次柱/档数:
                      </InputItem>
                    </div>
                  </>
                )}
              </Item>
              </CheckboxItem>
            ))}
        </List>
      </>
    );
  }
);

export default AgainList;
